import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
// import { useNavigate } from "react-router-dom";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import useWindowSize from "../../../hooks/useWindow";
import { useState } from "react";
import NoFilter from "../../../assets/images/unfiltered.svg";
import useStyles from "../styles";
import Table from "../../../components/Table/Table";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { Grid } from "@mui/material";
import { TableSearch } from "../../../components/Table/TableActions";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";

const AUDTI_TRAIL = "/api/v1/audit-trail/logs";

const index = () => {
  const classes = useStyles();
  const [filters, setFilters] = useState([]);
  const width = useWindowSize();
  const mobile = width < 600;
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [sidebarItem, setSidebarItem] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [isFiltering, setIsFiltering] = useState(false);
  const [auditModal, setAuditModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const handleAuditModal = (row) => {
    setCurrentRow(row);
    setAuditModal(!auditModal);
  };

  // Toggle a single event
  const handleCheckboxChange = (event) => {
    setSelectedEvents((prev) => prev.includes(event)
      ? prev.filter((e) => e !== event)
      : [...prev, event]
    );
  };

  // Toggle all events in a category
  const handleCategoryChange = (categoryKey, events) => {
    const categorySelected = selectedCategories.includes(categoryKey);

    if (categorySelected) {
    // Uncheck category
      setSelectedEvents((prev) => prev.filter((e) => !events.includes(e)));
      setSelectedCategories((prev) => prev.filter((c) => c !== categoryKey));
    } else {
    // Check category (only if less than 5 already selected)
      if (selectedCategories.length >= 5) {
        return;
      }

      setSelectedEvents((prev) => [...new Set([...prev, ...events])]);
      setSelectedCategories((prev) => [...prev, categoryKey]);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const eventData = [
    {
      title: "Class Management Events",
      categoryKey: "CLASS_MANAGEMENT",
      events: [
        "Class Created",
        "Class Updated",
        "Class Deleted"
      ]
    },
    {
      title: "Assessment Management Events",
      categoryKey: "ASSESSMENT_MANAGEMENT",
      events: [
        "Assessment Created",
        "Assessment Updated",
        "Assessment Deleted"
      ]
    },
    {
      title: "Assignment Management Events",
      categoryKey: "ASSIGNMENT_MANAGEMENT",
      events: [
        "Assignment Created",
        "Assignment Updated",
        "Assignment Deleted"
      ]
    },
    {
      title: "Attendance Management Events",
      categoryKey: "ATTENDANCE_MANAGEMENT",
      events: [
        "Attendance Marked",
        "Attendance Updated"
      ]
    },
    {
      title: "Bookmark Management Events",
      categoryKey: "BOOKMARK_MANAGEMENT",
      events: [
        "Bookmark Added",
        "Bookmark Removed"
      ]
    },
    {
      title: "Custom Report Management Events",
      categoryKey: "REPORT_MANAGEMENT",
      events: [
        "Custom Report Created",
        "Custom Report Updated"
      ]
    },
    {
      title: "Employee Management Events",
      categoryKey: "EMPLOYEE_MANAGEMENT",
      events: [
        "Employee Invited",
        "Employee Updated",
        "Employee Deleted",
        "Employee Reactivated"
      ]
    },
    {
      title: "Enrolment Management Events",
      categoryKey: "ENROLMENT_MANAGEMENT",
      events: [
        "Enrolment Created",
        "Enrolment Updated",
        "Applicant Created",
        "Applicant Updated",
        "Applicant Converted"
      ]
    },
    {
      title: "Exam Management Events",
      categoryKey: "EXAM_MANAGEMENT",
      events: [
        "School Exam Created",
        "School Exam Updated",
        "School Exam Deleted",
        "School Exam Converted",
        "Enrolment Exam Created",
        "Enrolment Exam Updated",
        "Enrolment Exam Deleted",
        "Exam Attached to Enrolment",
        "Exam Withdrawn from Enrolment"
      ]
    },
    {
      title: "Event Management Events",
      categoryKey: "EVENT_MANAGEMENT",
      events: [
        "Event Created",
        "Event Updated",
        "Event Deleted"
      ]
    },
    {
      title: "Teacher Management Events",
      categoryKey: "TEACHER_MANAGEMENT",
      events: [
        "Teacher Updated",
        "Teacher Deleted (Moved to Recycle Bin)"
      ]
    },
    {
      title: "Syllabus Management Events",
      categoryKey: "SYLLABUS_MANAGEMENT",
      events: [
        "Syllabus Created",
        "Syllabus Updated",
        "Syllabus Week Deleted",
        "Syllabus Deleted"
      ]
    },
    {
      title: "Subject Management Events",
      categoryKey: "SUBJECT_MANAGEMENT",
      events: [
        "Subject Created",
        "Subject Updated",
        "Subject Deleted",
        "Subject Assigned to Class",
        "Teacher Assigned to Subject",
        "Teacher Removed from Subject"
      ]
    },
    {
      title: "Student Management Events",
      categoryKey: "STUDENT_MANAGEMENT",
      events: [
        "Student Created",
        "Student Updated",
        "Student Deleted (Moved to Recycle Bin)",
        "Student Reactivated",
        "Student Promoted",
        "Students Batch Invited"
      ]
    },
    {
      title: "Report Management Events",
      categoryKey: "REPORT_MANAGEMENT",
      events: [
        "Report Saved",
        "Reports Marked Ready",
        "Reports Published",
        "Report Extras Saved",
        "Report Combined"
      ]
    },
    {
      title: "Leave Request Management Events",
      categoryKey: "LEAVE_MANAGEMENT",
      events: [
        "Leave Request Created",
        "Leave Request Updated",
        "Leave Request Deleted",
        "Leave Request Status Updated"
      ]
    },
    {
      title: "Role Management Events",
      categoryKey: "ROLE_MANAGEMENT",
      events: [
        "Role Created",
        "Role Updated",
        "Role Deleted",
        "Role Assigned to User"
      ]
    },
    {
      title: "Resource Management Events",
      categoryKey: "RESOURCE_MANAGEMENT",
      events: [
        "Label Created",
        "Label Updated",
        "Label Deleted",
        "Knowledge Base Info Created",
        "Knowledge Base Info Updated",
        "Knowledge Base Info Deleted",
        "Library Resource Added",
        "Library Resource Updated",
        "Library Resource Removed"
      ]
    },
    {
      title: "Promotion Management Events",
      categoryKey: "PROMOTION_MANAGEMENT",
      events: [
        "Students Promoted"
      ]
    },
    {
      title: "Procurement & Contractor Management Events",
      categoryKey: "PROCUREMENT_MANAGEMENT",
      events: [
        "Contractor Created",
        "Contractor Updated",
        "Contractor Deleted",
        "Procurement Entry Created",
        "Procurement Entry Updated",
        "Procurement Entry Deleted"
      ]
    },
    {
      title: "Period Management Events",
      categoryKey: "PERIOD_MANAGEMENT",
      events: [
        "Period Created",
        "Period Updated",
        "Period Deleted"
      ]
    },
    {
      title: "Goal & Performance Management Events",
      categoryKey: "GOAL_MANAGEMENT",
      events: [
        "Goal Category Created",
        "Goal Category Updated",
        "Goal Category Deleted",
        "Goal Created",
        "Employee Goal Updated",
        "Goal Deleted"
      ]
    },
    {
      title: "Grading Management Events",
      categoryKey: "GRADING_MANAGEMENT",
      events: [
        "Grading System Created",
        "Grading System Updated",
        "Grading System Deleted",
        "Student Graded",
        "Student Grade Updated",
        "Student Grade Deleted"
      ]
    },
    {
      title: "Obtainable Score Management Events",
      categoryKey: "SCORE_MANAGEMENT",
      events: [
        "Obtainable Score Created",
        "Obtainable Score Updated",
        "Obtainable Score Deleted"
      ]
    },
    {
      title: "Notice Board Management Events",
      categoryKey: "NOTICE_MANAGEMENT",
      events: [
        "Notice Created",
        "Notice Updated",
        "Notice Deleted"
      ]
    },
    {
      title: "Lesson Note & Outline Management Events",
      categoryKey: "LESSON_NOTE_MANAGEMENT",
      events: [
        "Lesson Note Created",
        "Lesson Note Updated",
        "Lesson Note Deleted (Moved to Recycle Bin)",
        "Lesson Outline Created",
        "Lesson Outline Updated",
        "Lesson Outline Deleted",
        "Draft Created",
        "Draft Updated",
        "Draft Deleted",
        "Draft Submitted",
        "Reviewer Assigned",
        "Lesson Outline Status Updated"
      ]
    },
    {
      title: "Inventory Management Events",
      categoryKey: "INVENTORY_MANAGEMENT",
      events: [
        "Inventory Category Created",
        "Inventory Category Updated",
        "Inventory Category Deleted",
        "Inventory Item Added",
        "Inventory Item Updated",
        "Inventory Item Deleted"
      ]
    },
    {
      title: "Exam Schedule Management Events",
      categoryKey: "EXAM_SCHEDULE_MANAGEMENT",
      events: [
        "Exam Schedule Created",
        "Exam Schedule Updated",
        "Exam Schedule Deleted",
        "Exam Schedule Detail Created",
        "Exam Schedule Detail Updated",
        "Exam Schedule Detail Deleted"
      ]
    }
  ];

  const handleApplyFilters = () => {
    setIsFiltering(true);
    let url = `${AUDTI_TRAIL}?`;

    // ✅ Add selected categories only
    if (selectedCategories.length > 0) {
      url += `categories=${selectedCategories.join(",")}&`;
    }

    // ✅ Add only events that don't belong to a fully selected category
    const filteredEvents = selectedEvents.filter((event) => {
      const parentCategory = eventData.find((group) => group.events.includes(event)
      )?.categoryKey;

      // only include if parent category is NOT selected
      return !selectedCategories.includes(parentCategory);
    });

    if (filteredEvents.length > 0) {
      url += `events=${filteredEvents.map((e) => encodeURIComponent(e)).join(",")}&`;
    }

    // ✅ Add date range if provided
    if (dateRange.from) {
      url += `from=${dateRange.from}&`;
    }
    if (dateRange.to) {
      url += `to=${dateRange.to}&`;
    }

    // ✅ remove trailing "&"
    url = url.endsWith("&") ? url.slice(0, -1) : url;

    httprequest
      .get(url)
      .then((res) => {
        setIsFiltering(false);
        toast.success("Filters applied successfully!");
        setFilters(res.data?.data?.data);
      })
      .catch((err) => {
        setIsFiltering(false);
        toast.error(err?.response?.data?.message || "Failed to apply filters");
      });
  };

  // Reset everything
  const handleReset = () => {
    setSelectedEvents([]);
    setSelectedCategories([]);
    setFilters([]);
    setDateRange({ from: "", to: "" });
  };

  const handleSidebarItem = () => {
    setSidebarItem(!sidebarItem);
  };

  const recentUser = [
    {
      name: "Event",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Event</p>}
          {row?.event || "--/--"}
        </>
      )
    },
    {
      name: "Updated at",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Updated at</p>}
          {row?.updated_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Operated By",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Operated By</p>}
          {`${row?.last_name || "--/--"} ${row?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Target",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Target</p>}
          {row?.target_type || "--/--"}
        </>
      )
    },
    {
      name: "Details",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Details</p>}
          {row?.details || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button onClick={() => handleAuditModal(row)} className="table-action-icon">
            <Icon icon="codicon:eye" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Inventory table using name, email and class
  const handleSearch = (e) => {
    const { value } = e.target;
    const valArray = value?.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = filters?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.gender
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.hostel_master?.last_name
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.hostel_master?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.hostel_master?.first_name
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setFilters(result);
  };

  return (
    <>
      <PageTitle
        title="Customize your View"
        subtitle="Use the Set Filters Button to customize your view and track activities"
        button={
          <div className="flex gap-10">
            <Button
              variant="primary"
              buttonSize="medium"
              color="btndefault"
              buttonName="Set Filters"
              onClick={handleSidebarItem}
            />
          </div>
        }
      />
      <div className="">
        <Grid
          container
          spacing={4}
          sx={{
            "@media (max-width: 1000px)": {
              flexWrap: "wrap-reverse"
            }
          }}
        >
          <Grid item lg={sidebarItem ? 8 : 12} md={sidebarItem ? 8 : 12} sm={12} xs={12}>
            <div className={`${classes.paddingcont}`}>
              <div className="left-container">
                {filters?.length > 0 ? (
                  <Table data={filters} columns={recentUser} subHeader={true} pagination subHeaderComponent={
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearch} />
                  }
                  />
                ) : (
                  <div className={classes.notfound}>
                    <NoData
                      img={NoFilter}
                      title="Customise your View"
                      subtitle="Use the Set Filters Button to customize your view and track activities"
                    />
                  </div>
                )}
              </div>
            </div>
          </Grid>
          {sidebarItem && (
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div className={`${classes.paddingcont} container-border`}>
                <div className={`${classes.rightcont}`}>
                  <Grid container spacing={2} className="input-padding">
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="From"
                        margin="normal"
                        placeHolder="Select Date"
                        inputType="date"
                        inputName="from"
                        onChange={handleDateChange}
                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="To"
                        margin="normal"
                        placeHolder="Select Date"
                        inputType="date"
                        inputName="to"
                        onChange={handleDateChange}
                      />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>
                        {eventData.map((group, index) => {
                          const allSelected = group.events.every((e) => selectedEvents.includes(e));

                          return (
                            <div key={index} className={classes.groupWrapper}>
                              <div className={classes.groupHeader}>
                                <div className="flex gap-10">
                                  <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={() => handleCategoryChange(group.categoryKey, group.events)}
                                  />
                                  <p className={classes.groupTitle}>{group.title}</p>
                                </div>
                                <p className={classes.selectedCount}>
                                  {selectedEvents.filter((e) => group.events.includes(e)).length} items selected
                                </p>
                              </div>

                              {group.events.map((event, idx) => (
                                <div key={idx} className={classes.checkboxRow}>
                                  <input
                                    type="checkbox"
                                    checked={selectedEvents.includes(event)}
                                    onChange={() => handleCheckboxChange(event)}
                                  />
                                  <label className={classes.checkboxLabel}>{event}</label>
                                </div>
                              ))}
                            </div>
                          );
                        })}

                      </div>

                    </Grid>
                  </Grid>
                  <div className={`${classes.exportbtn}`}>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Button
                          variant="primaryoutline"
                          color="btnfontprimary"
                          buttonSize="full"
                          buttonName="Reset"
                          onClick={handleReset}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <Button
                          variant="primaryoutline"
                          color="btnfontprimary"
                          buttonSize="full"
                          buttonName="Apply Filters"
                          isLoading={isFiltering}
                          onClick={handleApplyFilters}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            </Grid>
          )}
        </Grid>

        {/* Create Hostels */}
        <Modal
          title="Audit Trail Details"
          subtitle={
            <div>
                The audit trail detials are listed below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Event</p>
                      <h4>{currentRow?.event || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Email</p>
                      <h4>{currentRow?.email || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Details</p>
                      <h4>{currentRow?.details || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Updated By</p>
                      <h4>{`${currentRow?.last_name || "--/--"} ${currentRow?.first_name || "--/--"}`}</h4>
                    </div>
                  </div>
                </Grid>
                {currentRow?.deleted_at && (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Deleted By</p>
                        <h4>{currentRow?.deleted_at?.substring(0, 10)}</h4>
                      </div>
                    </div>
                  </Grid>
                )}
                {currentRow?.updated_at && (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <p>Updated at</p>
                        <h4>{currentRow?.updated_at?.substring(0, 10)}</h4>
                      </div>
                    </div>
                  </Grid>
                )}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <div className={`${classes.previewsubheader} text-align-left`}>
                    <div>
                      <p>Target Name</p>
                      <h4>{currentRow?.target_name || "--/--"}</h4>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={auditModal}
          closeModal={() => setAuditModal(false)}
        />
      </div>
      {/* <ToastContainer /> */}
    </>
  );
};

export default index;
